// extracted by mini-css-extract-plugin
module.exports = {"overview_section":"overview_overview_section__SNH3V","overview_section_title":"overview_overview_section_title__1CdiI"};